import { ButtonReset } from '@helpers/global';
import { between, Device, until } from '@helpers/media';
import DotPaginationStyles from '@stories/Components/Misc/DotPagination/DotPagination.styles';
import styled from 'styled-components';
const Container = styled.nav `
  display: flex;
  gap: 16px;
  padding: 4px 0;
  place-content: center;
  place-items: center;

  /* Hide dots on mobile, to prevent close together buttons being flagged */
  @media ${until(Device.MobileLarge)} {
    ${DotPaginationStyles.Container} {
      display: none;
    }
  }

  &[data-item-amount='true'] {
    @media ${between(Device.MobileLarge, Device.Tablet)} {
      ${DotPaginationStyles.Container} {
        display: none;
      }
    }
  }
`;
const Button = styled.button `
  ${ButtonReset}
  display: flex;
  border-radius: 50%;
  height: 48px;
  place-content: center;
  place-items: center;
  width: 48px;

  svg {
    display: block;
    height: 18px;
    width: 28px;
  }

  &:disabled {
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:focus,
    &:hover {
      outline: auto;
    }
  }
`;
const ControlsStyles = {
    Button,
    Container,
};
export default ControlsStyles;
